export async function generateCompatibility(userProfile, matchProfile) {
    try {
      const apiKey = process.env.REACT_APP_GEMINI_API_KEY
  
      const prompt = `You are the matching engine for Sauce — a Bangalore going-out app.
  
  Person A:
  - Name: ${userProfile.full_name || 'Unknown'}
  - Area: ${userProfile.area || 'Bangalore'}
  - Craving: ${userProfile.food_type || 'food'}
  - Meal time: ${userProfile.time_slot || 'dinner'}
  
  Person B:
  - Name: ${matchProfile.full_name || 'Unknown'}
  - Area: ${matchProfile.area || 'Bangalore'}
  - Craving: ${matchProfile.food_type || 'food'}
  - Meal time: ${matchProfile.time_slot || 'dinner'}
  
  Generate a compatibility score and witty sauce line.
  Max 12 words for the line. Warm, cheeky, specific to their data.
  
  Respond ONLY in this exact JSON with no extra text:
  {"score": 85, "sauce_line": "your witty line here"}`
  
      const response = await fetch(
        `https://generativelanguage.googleapis.com/v1/models/gemini-2.5-flash:generateContent?key=${apiKey}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            contents: [{ parts: [{ text: prompt }] }]
          })
        }
      )
  
      const data = await response.json()
      console.log('Gemini response:', data)
  
      if (!response.ok) {
        console.error('Gemini API error:', data)
        throw new Error(data.error?.message || 'API error')
      }
  
      const text = data.candidates?.[0]?.content?.parts?.[0]?.text || ''
      const clean = text.replace(/```json|```/g, '').trim()
      const parsed = JSON.parse(clean)
  
      return {
        score: Math.min(99, Math.max(50, parsed.score)),
        sauce_line: parsed.sauce_line
      }
  
    } catch (err) {
      console.error('Gemini error:', err)
      return {
        score: 75,
        sauce_line: "You'd probably fight over the last piece but split the bill perfectly"
      }
    }
  }